<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="40%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
        <div>
            <v-card class="cardWrap">
                <CardTitle title="プラン詳細" />
                <v-container class="mb-2 titleContainer">
                    <v-row>
                        <v-col
                            cols="8">
                            {{planName}}
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-container>
                <v-container>
                    <v-row>
                        <v-col cols="3">プレースタイル</v-col>
                        <v-col>昼食</v-col>
                        <v-col>{{mealFlagName}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">カート</v-col>
                        <v-col>{{cartCodeName}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">人数</v-col>
                        <v-col>{{guaranteeCodeName}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">キャディー</v-col>
                        <v-col>{{caddieFlagName}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">ラウンド数</v-col>
                        <v-col>{{roundCodeName}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">料金</v-col>
                        <v-col>総額（税込）</v-col>
                        <v-col>￥{{totalFee}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3"></v-col>
                        <v-col>料金（税抜）</v-col>
                        <v-col>￥{{baseFee}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3"></v-col>
                        <v-col>消費税</v-col>
                        <v-col>￥{{taxSales}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3"></v-col>
                        <v-col>利用税</v-col>
                        <v-col>￥{{taxUsage}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3"></v-col>
                        <v-col>諸経費</v-col>
                        <v-col>￥{{taxOthers}}</v-col>
                    </v-row>
                    <v-row class="border_none">
                        <v-col cols="3">割増料金</v-col>
                        <v-col>平日2サム割増</v-col>
                        <v-col>{{addFee2bWeekday}}</v-col>
                    </v-row>
                    <v-row class="border_none">
                        <v-col cols="3"></v-col>
                        <v-col>平日3サム割増</v-col>
                        <v-col>{{addFee3bWeekday}}</v-col>
                    </v-row>
                    <v-row class="border_none">
                        <v-col cols="3"></v-col>
                        <v-col>土日祝2サム割増</v-col>
                        <v-col>{{addFee2bWeekend}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3"></v-col>
                        <v-col>土日祝3サム割増</v-col>
                        <v-col>{{addFee3bWeekend}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">通常ポイント</v-col>
                        <v-col>通常ポイントを差し上げます。</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">期間限定</v-col>
                        <v-col>{{releaseValid}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">備考</v-col>
                        <v-col style="white-space: pre-line;">{{detail}}</v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="onClose">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </div>
        </v-dialog>
    </v-row>
</template>

<script>
import { GET_PLAN_INF_FROM_ADMIN } from '@/constants/plan';
import CardTitle from '@/components/module/CardTitle';

export default {
    components: {
        CardTitle
    },
    data () {
        return {
            dialog: false,
            planName: null,
            mealFlagName: null,
            cartCodeName: null,
            guaranteeCodeName: null,
            caddieFlagName: null,
            roundCodeName: null,
            totalFee: null,
            taxUsage: null,
            taxOthers: null,
            baseFee: null,
            taxSales: null,
            addFee2bWeekday: null,
            addFee3bWeekday: null,
            addFee2bWeekend: null,
            addFee3bWeekend: null,
            releaseValid: null,
            detail: null
        };
    },
    methods: {
        /** ----------------------------------------------
         * 画面表示処理
         * ---------------------------------------------- */
        async ModalControl (golfCode, planId, playDate) {
            this.dialog = true;
            this.$apollo.query({
                query: GET_PLAN_INF_FROM_ADMIN,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: golfCode,
                    plan_id: planId,
                    play_date: playDate
                }
            }).then(res => {
                this.setPlandetail(res.data.getPlanInfFromAdmin.PlanInfList[0]);
            }).catch(error => {
                const message = error.message.split(':');
                this.message = message;
            });
        },
        /** ----------------------------------------------
         * プラン詳細設定処理
         * ---------------------------------------------- */
        setPlandetail (planInfRec) {
            this.planName = planInfRec.plan_name;
            this.mealFlagName = planInfRec.meal_flag_name;
            this.cartCodeName = planInfRec.cart_code_name;
            this.guaranteeCodeName = planInfRec.guarantee_code_name;
            this.caddieFlagName = planInfRec.caddie_flag_name;
            this.roundCodeName = planInfRec.round_code_name;
            this.taxUsage = planInfRec.tax_usage.toLocaleString();
            this.taxOthers = planInfRec.tax_others.toLocaleString();
            this.totalFee = planInfRec.total_fee.toLocaleString();
            this.baseFee = planInfRec.base_fee.toLocaleString();
            this.taxSales = planInfRec.tax_sales.toLocaleString();
            if (planInfRec.add_fee_2b_weekday == null || planInfRec.add_fee_2b_weekday === 0) {
                this.addFee2bWeekday = '無し';
            } else {
                this.addFee2bWeekday = '￥' + planInfRec.add_fee_2b_weekday.toLocaleString();
            }
            if (planInfRec.add_fee_3b_weekday === null || planInfRec.add_fee_3b_weekday === 0) {
                this.addFee3bWeekday = '無し';
            } else {
                this.addFee3bWeekday = '￥' + planInfRec.add_fee_3b_weekday.toLocaleString();
            }
            if (planInfRec.add_fee_2b_weekend === null || planInfRec.add_fee_2b_weekend === 0) {
                this.addFee2bWeekend = '無し';
            } else {
                this.addFee2bWeekend = '￥' + planInfRec.add_fee_2b_weekend.toLocaleString();
            }
            if (planInfRec.add_fee_3b_weekend === null || planInfRec.add_fee_3b_weekend === 0) {
                this.addFee3bWeekend = '無し';
            } else {
                this.addFee3bWeekend = '￥' + planInfRec.add_fee_3b_weekend.toLocaleString();
            }
            var tempDate = new Date(planInfRec.release_valid);
            this.releaseValid = (tempDate.getUTCMonth() + 1) + '月' +
                                (tempDate.getUTCDate()) + '日まで予約可能です。';
            this.detail = planInfRec.detail;
        },
        /** ----------------------------------------------
         * 閉じるボタン押下処理
         * ---------------------------------------------- */
        onClose () {
            this.dialog = false;
        }
    }
};

</script>

<style scoped>

.row{
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
/* .container .row:first-child{
    border-top:  1px solid rgba(0, 0, 0, 0.12);
} */
.border_none {
    border-bottom: none;
}
</style>
